import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";

import type { FCWithChildren } from "koljobs-types";

import { AuthFooter } from "@/features/auth/components/AuthFooter";
import { userRoleSlug } from "@/features/user/consts/userRoleSlug";
import { UserRoleEnum } from "@/generated/graphql-hooks";
import { getPublicConfig } from "@/helpers/getPublicConfig";

const {
  project: { siteName },
} = getPublicConfig();

export type AuthCardProps = {
  authType?: "signin" | "signup";
  hideFooter?: boolean;
};

export const AuthCard: FCWithChildren<AuthCardProps> = ({
  authType = "signup",
  hideFooter,
  children,
}) => {
  const { query } = useRouter();

  return (
    <div className="flex h-full items-center justify-center">
      <div className="mx-6 flex w-full rounded-lg bg-white px-4 py-6 shadow-lg sm:min-h-[70%] sm:max-w-4xl sm:px-0 sm:py-0">
        <div className="relative hidden w-[700px] sm:block">
          <Image
            className="rounded-l-lg"
            layout="fill"
            objectFit="cover"
            src={`/images/${authType}/${authType}_banner.png`}
            alt={siteName}
          />
          <div className="absolute inset-0 bg-gray-100 mix-blend-multiply" />
          <Link
            href="/"
            passHref
            className="absolute left-1/2 top-16 flex w-max -translate-x-1/2 items-end justify-center space-x-2"
          >
            <Image
              alt={siteName}
              src="/images/logo_white.png"
              layout="fixed"
              width={201}
              height={30}
              unoptimized
            />
            {query?.role === userRoleSlug[UserRoleEnum.Business] && (
              <div className="rounded-full bg-white px-2 py-0.5 text-xs font-medium">
                商戶版
              </div>
            )}
          </Link>
          {!hideFooter && (
            <div className="absolute left-1/2 bottom-10 w-full -translate-x-1/2 px-16">
              <AuthFooter />
            </div>
          )}
        </div>
        <div className="flex w-full items-center justify-center sm:px-14 sm:py-10">
          {children}
        </div>
      </div>
    </div>
  );
};
